import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import PrivacyModalBox from "../../components/PrivacyModalBox/PrivacyModalBox";
import OurSupporters from "../../components/OurSupporters/OurSupporters";
import ContactUs from '../../components/ContactUs/ContactUs'
import "./header.scss";
import AxiosInstance from "../../services/axios";
import draftToHtml from 'draftjs-to-html';
import { Link, useLocation, useNavigate } from "react-router-dom";


const Header = (props) => {
  const [isActive, setIsActive] = useState(false);
  let history = useNavigate();
  const [privModalOpen, setPrivModalOpen] = useState(false);
  const [supportModalOpen, setSupportModalOpen] = useState(false);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [contactList, setContactList] = useState('');
  const [policyList, setPolicyList] = useState('');
  const { pathname } = useLocation();
  let filterServiceWrap = (localStorage.getItem('serviceFilter'));
  let activeMenu = '';

  if (pathname.indexOf("/") !== -1) { activeMenu = "/"; }
  if (pathname.indexOf("/event") !== -1) { activeMenu = "event"; }
  if (pathname.indexOf("/bookmark") !== -1) { activeMenu = "bookmark"; }


  const modalClose = () => {
    setPrivModalOpen(false)
    setSupportModalOpen(false)
    setContactModalOpen(false)
  };

  useEffect(() => {
    getContact()
  }, [])
  useEffect(() => {
    getPolicies()
  }, [])

  const getContact = async () => {
    await AxiosInstance.get(`user/getContactInfo`)
      .then((res) => {
        setContactList(res.payload);
      }).catch((e) => {
      })
  }


  const getPolicies = async () => {
    await AxiosInstance.get(`user/getPrivacyPolicy`)
      .then((res) => {

        let data = JSON.parse(res.payload.privacyPolicy);
        let privacyString = draftToHtml(data);
        setPolicyList(privacyString);
      }).catch((e) => {
      })
  }

  return (
    <div className="navWrap">
      <Navbar bg="white" expand="lg">
        <Container fluid className="p-0">
          <Navbar id="basic-navbar-nav">
            <Nav className="me-auto" activeKey={activeMenu}>
              <Nav.Link eventKey="/" as={Link} to="/" onClick={() => history.push("/")}>
                <span className="icon icon-home"></span> Home
              </Nav.Link>
              <Nav.Link eventKey="event" as={Link} to="/event" >
                <span className="icon icon-event"></span> Event
              </Nav.Link>
              <Nav.Link
                eventKey="bookmark" as={Link} to="/bookmark"
              >
                <span className="icon icon-bookmark"></span> Bookmark
              </Nav.Link>
            </Nav>
            <NavDropdown
              className="ms-auto"
              title={<span className="icon-dots"></span>}
              id="basic-nav-dropdown"
            >
              <NavDropdown.Item onClick={() => setContactModalOpen(true)}>
                <span className="icon icon-phone"></span>Contact Us
              </NavDropdown.Item>

              <NavDropdown.Item onClick={() => setPrivModalOpen(true)}>
                <span
                  className="icon icon-privacy-policy"
                ></span>
                Privacy Policy
              </NavDropdown.Item>
              <NavDropdown.Item onClick={() => setSupportModalOpen(true)}>
                <span className="icon icon-supporters"></span>Our Supporters
              </NavDropdown.Item>
            </NavDropdown>
          </Navbar>
        </Container>
      </Navbar>

      {/* <PrivacyModalBox showModal={privModalOpen} modalClose={modalClose} /> */}
      <PrivacyModalBox showModal={privModalOpen} modalClose={modalClose} policyData={policyList} />
      <OurSupporters showModal={supportModalOpen} modalClose={modalClose} />
      <ContactUs showModal={contactModalOpen} modalClose={modalClose} contactData={contactList} />


    </div>
  );
};

export default Header;
